export enum EntityPropertyTypes {
  Primitive = "Primitive",
  Object = "Object",
  ArrayPrimitive = "ArrayPrimitive",
  ArrayObject = "ArrayObject",
}

export enum EntityPropertyChanges {
  Added,
  Changed,
  /** A key or column that held a value and was removed or cleared. */
  Removed,
  /** A collection (ids or items with ids) gained or lost items, or its order changed. */
  ItemsChanged,
}
